import React from 'react';
import { useTranslation } from 'react-i18next';
import ProFeatureDialog from '@/components/ProFeatureDialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Take the user to the plans page. */
  onUpgrade: () => void;
}

/** Shown when a free user clicks Export on a clip that contains media layers.
 *
 *  The Export button stays CLICKABLE for free users — a disabled button plus a
 *  passive banner explained nothing at the moment of intent. Clicking is the
 *  moment the user cares, so that is when we explain: layers are free to add
 *  and preview, but exporting the final video with them is PRO — upgrade, or
 *  remove the layers to export free. */
export const LayersProExportDialog: React.FC<Props> = ({ open, onOpenChange, onUpgrade }) => {
  const { t } = useTranslation();
  return (
    <ProFeatureDialog
      open={open}
      onOpenChange={onOpenChange}
      onUpgrade={onUpgrade}
      title={t('projectEditor.layers.proExportDialogTitle')}
      body={t('projectEditor.layers.proExportDialogBody')}
      dismissLabel={t('projectEditor.layers.proExportDialogDismiss')}
      upgradeLabel={t('projectEditor.layers.proExportDialogUpgrade')}
      testIdPrefix="layers-pro"
    />
  );
};

export default LayersProExportDialog;
